module.exports = __webpack_public_path__ + "img/hold.c52b214f.png";